export default __webpack_public_path__ + "static/img6-e0e8451b4d9963c4d529e40ebd0bcf5f.png";